import PdfLayout from '../PdfLayout';
import CustomTextWidget from './CustomTextWidget';

/**
 * Text widget showing a field from a CMS / blog post resolved at render time.
 */
class PostInfoWidget extends CustomTextWidget {

    constructor(properties) {
        super({
            ...(PostInfoWidget.getDefaultOptions()),
            ...properties,
        });

        this.type    = PdfLayout.TEXT;
        this.subType = PdfLayout.POST_INFO;
    }

    static getDefaultOptions() {
        return {
            position: { x: 2, y: 2, z: 0 },
            dimensions: { width: 8, height: 1.2 },
            transform: { rotation: 0 },
            options: {
                field: 'title',
                mode: 'latest',
                category_id: '',
                post_id: '',
                post_key: 'default',
                style: {
                    color: '#000000',
                    fontFamily: 'Helvetica',
                    fontSize: 14,
                    lineHeight: 1.2,
                    textAlign: 'left',
                    textDecoration: 'none',
                    textStrokeWidth: 0,
                    textStrokeColor: '#000000',
                    backgroundColor: '#FFFFFF00',
                    borderStyle: 'solid',
                    borderWidth: 0,
                    borderColor: '#000000',
                    borderRadius: 0,
                    padding: {
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                    },
                    textTransform: 'none',
                },
            },
        };
    }

    getHandledOptions() {
        return super.getHandledOptions().concat([
            PdfLayout.OPTION_POST_FIELD,
            PdfLayout.OPTION_POST_SELECTION,
        ]).filter(o => o !== PdfLayout.OPTION_TEXT);
    }

    getPreviewText(_props) {
        switch (this.options?.field) {
            case 'sub_title':
                return 'Post subtitle…';
            case 'content':
                return 'Post content excerpt…';
            case 'title':
            default:
                return 'Post title…';
        }
    }

    getIcon() {
        return 'newspaper-o';
    }
}

export default PostInfoWidget;
